import React from "react"
import { IconSeeker, LoadingIconSeeker, TabsSeeker } from "@ui-seeker/core"
import { batch } from "@preact/signals-react"

import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import { clearSignals } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import {
	alertsSection,
	isMinMaxPriceTabEmpty,
	isMinMaxPriceTabLoading,
	isNoAvailabilityTabEmpty,
	isNoAvailabilityTabLoading,
	isPriceChangeTabEmpty,
	isPriceChangeTabLoading,
	isPriceComparisonTabEmpty,
	isPriceComparisonTabLoading,
	isRatingTabEmpty,
	isRatingTabLoading
} from "Pages/ReportsAlerts/Alerts/@signals"


export default function AlertsTabs() {

	const setTab = (_, value) => batch(() => {
		clearSignals()
		alertsSection.value = value
	})

	return <TabsSeeker
		onChange={setTab}
		value={alertsSection.value}
		tabs={
			[{
				key: ALERTS.PRICE_COMPARISON,
				label: 'Price Comparison',
				disabled: isPriceComparisonTabLoading.value || isPriceComparisonTabEmpty.value,
				value: ALERTS.PRICE_COMPARISON,
				iconPosition: 'end',
				icon: isPriceComparisonTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon="hand-holding-dollar"/>,
				sx: {
					fontSize: "1.2rem"
				}
			}, {
				key: ALERTS.NO_AVAILABILITY,
				label: 'Not Available',
				disabled: isNoAvailabilityTabLoading.value || isNoAvailabilityTabEmpty.value,
				value: ALERTS.NO_AVAILABILITY,
				iconPosition: 'end',
				icon: isNoAvailabilityTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon="circle-xmark"/>,
				sx: {
					fontSize: "1.2rem"
				}
			}, {
				key: ALERTS.PRICE_CHANGE,
				label: 'Price Change',
				disabled: isPriceChangeTabLoading.value || isPriceChangeTabEmpty.value,
				value: ALERTS.PRICE_CHANGE,
				iconPosition: 'end',
				icon: isPriceChangeTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon="money-bill-1-wave"/>,
				sx: {
					fontSize: "1.2rem"
				},
			}, {
				key: ALERTS.MIN_MAX_PRICE,
				label: 'Min & Max Price',
				disabled: isMinMaxPriceTabLoading.value || isMinMaxPriceTabEmpty.value,
				value: ALERTS.MIN_MAX_PRICE,
				iconPosition: 'end',
				icon: isMinMaxPriceTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon="plus-minus"/>,
				sx: {
					fontSize: "1.2rem"
				},
			}, {
				key: ALERTS.RATING,
				label: 'Rating',
				disabled: isRatingTabLoading.value || isRatingTabEmpty.value,
				value: ALERTS.RATING,
				iconPosition: 'end',
				icon: isRatingTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon="star-half-stroke"/>,
				sx: {
					fontSize: "1.2rem"
				},
			}]
		}
	/>
}